import React, { useEffect, useState, useContext, useRef } from 'react';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import Typography from '@mui/material/Typography';
import BugReport from '@mui/icons-material/BugReport';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Item from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';

import { DataContext } from 'contexts/DataContext';

import 'i18n/config';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { get, update } from './api';

const ThreatsProbability = () => {
    const dataContext = useContext(DataContext);
    const { t } = useTranslation();
    const [threats, setThreats] = useState([]);
    const [probability, setProbability] = useState({} as any);
    const [saving, setSaving] = useState(false);
    const formRef = useRef<HTMLFormElement>(null);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        dataContext.changeShowLoader(true);
        const data = new FormData(event.currentTarget);
        console.log(data);
        update(dataContext.currentOrganization, data).then((response) => {
            setProbability(response.probability);
            toast.success('Probability saved', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
            
            setTimeout(() => {
                setSaving(false);
                dataContext.changeShowLoader(false);
            }, 400);
        });
    };

    useEffect(() => {
        if(dataContext.loading) return;
        if(!dataContext.currentOrganization) return;
        get(dataContext.currentOrganization).then((response) => {
            setThreats(response.threats);
            setProbability(response.probability);
        });
    }, [dataContext.loading,dataContext.currentOrganization]);
    
    return (
        <AppLayout drawerOpen={true} drawer={<AppDrawer />} 
        title={<><Typography variant='pageTitle'>{t('Threats Probability')}</Typography></>} 
        actions={dataContext.user?.id_role===1 ? [] :[
            {
                label: saving ? t('Saving...') : t('Save'),
                action: () => {
                    formRef.current?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                }
            }
        ]}>
        


        <Box ref={formRef} component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 0 }}>
        
        {threats.map((threat: any, index:number) => {

        
        return <Paper key={index} sx={{marginTop:1, padding:1}}>
            <Box sx={{margin:1}}>
                <Grid container spacing={2} alignItems='center'>
                    <Grid item xs={1} sx={{textAlign:'center'}}>
                        <Item>         
                            <Typography variant='paperTitle'>{threat.id}</Typography>
                        </Item>
                    </Grid>
                    <Grid item xs={10}>
                        <Item>
                        <Typography variant='paperTitle'>{threat.name}</Typography>
                            <Typography component='div' sx={{fontSize:11}}>
                                <div dangerouslySetInnerHTML={{__html: threat.samples}}></div>
                            </Typography>
                        </Item>
                    </Grid>

                    <Grid item xs={1}>
                        <Item>
                            <FormControl fullWidth>
                                <TextField
                                    name={`probability[${threat.id}]`}
                                    type='number'
                                    variant="filled"
                                    size='small'
                                    hiddenLabel
                                    fullWidth
                                    key={probability.find((item: any) => item.id_threat===threat.id) ? probability.find((item: any) => item.id_threat===threat.id).probability : threat.probability}
                                    defaultValue={probability.find((item: any) => item.id_threat===threat.id) ? probability.find((item: any) => item.id_threat===threat.id).probability : threat.probability}
                                    disabled={dataContext.user?.id_role===1}
                                />
                            </FormControl>
                        </Item>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
        })}

        </Box>




      </AppLayout>
    )
}

export default ThreatsProbability;